import * as _ from 'lodash'

import { InvoiceItem, OrderResponseItem } from '../../data/models'

export function calculateOrderResponseItemPriceSum(item: OrderResponseItem) {
  return calculateItemPrice(
    item.ConfirmationQuantity,
    item.ConfirmationPriceBaseQuantity,
    item.ConfirmationPrice,
  )
}

export function calculateInvoiceItemPriceSum(item: InvoiceItem) {
  return calculateItemPrice(
    item.ConfirmationQuantity,
    item.ConfirmationPriceBaseQuantity,
    item.ConfirmationPrice,
  )
}

export function calculateItemPrice(
  confirmationQuantity: number,
  confirmationPriceBaseQuantity: number,
  confirmationPrice: number,
): number {
  const quantity = confirmationQuantity || 0
  const baseQuantity = confirmationPriceBaseQuantity || 0
  const price = confirmationPrice || 0

  if (baseQuantity <= 0)
    throw new Error(
      `Argument confirmationPriceBaseQuantity cannot be zero or less.`,
    )

  if (quantity < 0)
    throw new Error(`Argument confirmationQuantity cannot be less than zero.`)

  const itemPrice = _.round((quantity / baseQuantity) * price, 2)

  return itemPrice
}
